import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-bloco-relatorios',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './bloco-relatorios.component.html',
  styleUrls: ['./bloco-relatorios.component.scss'],
})
export class BlocoRelatoriosComponent {
  @Input() level: string = '';

  constructor(private readonly router: Router) {}

  irParaRelatorios(): void {
    this.router.navigate(['/relatorios']);
  }
}